export const formatPlayerDataForCSV = (players) => {
  const headers = ["Player Name", "Total Buy-ins", "Total Cash Outs", "Net Profit/Loss", "Number of Buy-ins", "Number of Cash Outs", "Average Buy-in", "Average Cash Out", "Created Date"];
  
  const rows = players.map(player => {
    const buyInCount = player.buyInHistory ? player.buyInHistory.length : 0;
    const cashOutCount = player.cashOutHistory ? player.cashOutHistory.length : 0;
    const totalCashOut = player.totalCashOut || 0;
    const netProfitLoss = totalCashOut - player.totalBuyIn;
    const averageBuyIn = buyInCount > 0 ? player.totalBuyIn / buyInCount : 0;
    const averageCashOut = cashOutCount > 0 ? totalCashOut / cashOutCount : 0;
    const createdDate = player.createdAt ? new Date(player.createdAt).toLocaleDateString() : "N/A";
    
    return [
      player.name,
      `$${player.totalBuyIn.toFixed(2)}`,
      `$${totalCashOut.toFixed(2)}`,
      `${netProfitLoss >= 0 ? '+' : ''}$${netProfitLoss.toFixed(2)}`,
      buyInCount.toString(),
      cashOutCount.toString(),
      `$${averageBuyIn.toFixed(2)}`,
      `$${averageCashOut.toFixed(2)}`,
      createdDate
    ];
  });
  
  return [headers, ...rows];
};

export const formatPlayerHistoryForCSV = (player) => {
  const headers = ["Type", "Date", "Amount", "Note"];
  
  const allTransactions = [];
  
  // Add buy-ins
  if (player.buyInHistory) {
    player.buyInHistory.forEach(buyIn => {
      allTransactions.push({
        type: "Buy-in",
        timestamp: buyIn.timestamp,
        amount: buyIn.amount,
        note: buyIn.note || ""
      });
    });
  }
  
  // Add cash outs
  if (player.cashOutHistory) {
    player.cashOutHistory.forEach(cashOut => {
      allTransactions.push({
        type: "Cash Out",
        timestamp: cashOut.timestamp,
        amount: cashOut.amount,
        note: cashOut.note || ""
      });
    });
  }
  
  if (allTransactions.length === 0) {
    return [headers];
  }
  
  // Sort by timestamp (newest first)
  allTransactions.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  
  const rows = allTransactions.map(transaction => [
    transaction.type,
    new Date(transaction.timestamp).toLocaleString(),
    `$${transaction.amount.toFixed(2)}`,
    transaction.note
  ]);
  
  return [headers, ...rows];
};

export const downloadCSV = (data, filename) => {
  const csvContent = data.map(row => 
    row.map(field => {
      // Escape quotes and wrap in quotes if contains comma, quote, or newline
      const stringField = String(field);
      if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
        return `"${stringField.replace(/"/g, '""')}"`;
      }
      return stringField;
    }).join(",")
  ).join("\n");
  
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const generateFilename = (prefix, playerName = null, sessionName = null) => {
  const timestamp = new Date().toISOString().split('T')[0];
  let filename = prefix;
  
  if (sessionName) {
    const cleanSessionName = sessionName.replace(/[^a-zA-Z0-9]/g, '_');
    filename += `_${cleanSessionName}`;
  }
  
  if (playerName) {
    const cleanPlayerName = playerName.replace(/[^a-zA-Z0-9]/g, '_');
    filename += `_${cleanPlayerName}`;
  }
  
  filename += `_${timestamp}.csv`;
  
  return filename;
};